export const style = {
	marginTop: '12px',
};
export const topBar = {
	boxShadow: '0 8px 6px -4px rgba(0,0,0,0.10)',
	padding: '40px',
	position: 'relative',
};
